import * as TYPES from "./_store/types";

export async function asyncData(store) {
    await loadData.call(this, store)
    await getSocialLinks.call(this, store)   
}

export async function loadData(store, refresh = false) {

    if (refresh) {
        store[TYPES.SET_POSTS]({ posts: [], pageNo: 0, hasMore: true })
    }
    if (!this.source || !this.delegateUserId || !this.source.length) {
        return;
    }
    const pageNo = store.pageNo + 1
    const res = await this.axiosIns
        .post('/social-media/cms/pullSocialPost', {
            agentId: this.delegateUserId,
            socialTypes: this.source,
            pageNum: pageNo,
            pageSize: 8
        })
    const { result, total } = res.data || {
        result: [],
        total: 0
    };
    // process the list data
    let list = result.map(v => {
        v.images = (v.images || []).filter(Boolean);
        return v;
    });
    const posts = [...store.posts, ...list]
    store[TYPES.SET_POSTS]({ posts, pageNo, hasMore: total > posts.length })
}

export async function getSocialLinks(store) {
    const res = await this.axiosIns
        .post(
            `/social-media/cms/social-media-link/${this.delegateUserId}`,
            this.source
        )
    store[TYPES.SET_SOCIAL_LINKS](res.data || [])
}